import { render, staticRenderFns } from "./ModalCasadinha.vue?vue&type=template&id=587048b6&scoped=true"
import script from "./ModalCasadinha.vue?vue&type=script&lang=js"
export * from "./ModalCasadinha.vue?vue&type=script&lang=js"
import style0 from "./ModalCasadinha.vue?vue&type=style&index=0&id=587048b6&prod&lang=scss&scoped=true"
import style1 from "./ModalCasadinha.vue?vue&type=style&index=1&id=587048b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587048b6",
  null
  
)

export default component.exports